// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ant-form-item {\n  margin-bottom: 6px;\n}\n.flow-attr-box .el-tabs__header {\n  margin-bottom: 0;\n}\n.flow-attr-box .el-tabs__item.is-active {\n  color: #1a96d4 !important;\n}\n.flow-attr-box .el-tabs__item.is-disabled {\n  color: #333;\n}\n.flow-attr-box .el-tabs__content {\n  height: calc(100% - 40px);\n  overflow: auto;\n  padding: 0 10px;\n}", ""]);
// Exports
module.exports = exports;
